import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import {
  FocusContext,
  FocusDetails,
  FocusableComponentLayout,
  useFocusable
} from '@noriginmedia/norigin-spatial-navigation';
import Button from '@smart-tv/components/button/button';
import { Buttons } from '../button-group/button-group';
import { UrlParams } from '../stripes/_utils/types';

import styles from './provider-universe-menu.module.scss';
import { testIds } from '@smart-tv/e2e/shared/variables';

export interface Props {
  navigationContent: Buttons[];
  onFocus: (layout: FocusableComponentLayout, props: object, details: FocusDetails) => void;
  setIsRendered: Dispatch<SetStateAction<boolean>>;
}

export const ProviderUniverseMenu: React.FC<Props> = (props: Props) => {
  const { onFocus, navigationContent, setIsRendered } = props;
  const { focusKey, ref } = useFocusable({
    onFocus
  });
  const { universetitle } = useParams() as UrlParams;

  useEffect(() => {
    setIsRendered(true);

    return () => {
      setIsRendered(false);
    };
  }, [setIsRendered]);

  return (
    <FocusContext.Provider value={focusKey}>
      {navigationContent && (
        <div ref={ref} className={styles['provider-universe-menu']} data-testid={testIds.providerUniverse.menuBar}>
          {navigationContent.map(({ label, onEnterPress, selected, dataTestId }, index) => (
            <Button
              key={`${label}-${index}`}
              onClick={() => onEnterPress?.()}
              selected={selected}
              data-testid={dataTestId?.toLowerCase()}
              isFocused={universetitle !== undefined && label === universetitle}
              className={styles['provider-universe-menu__button']}
              size="sm"
              expandOnFocus={true}
              variant="outline"
            >
              {label}
            </Button>
          ))}
        </div>
      )}
    </FocusContext.Provider>
  );
};

export default React.memo(ProviderUniverseMenu);
